import { Button } from "@mui/material";

const WishlinkButton = (props) => {
  const {
    background,
    borderRadius = "0.5rem",
    boxShadow,
    width = "100%",
    height,
    border,
    disabled,
    className,
    onClick,
    style,
    parentDivStyle,
    buttonClassName,
    opacity = 1,
    variant = undefined,
    dataCy,
    id,
  } = props;
  return (
    <div id={id} className={className} style={parentDivStyle}>
      <Button
        variant={variant}
        sx={{
          background,
          borderRadius,
          boxShadow,
          width,
          height,
          textTransform: "none",
          border,
          opacity,
          minWidth: "0px",
          color: "#fff",
          ...style,
        }}
        disabled={disabled}
        onClick={onClick}
        className={buttonClassName}
        data-cy={dataCy}
      >
        {props.children}
      </Button>
    </div>
  );
};

export default WishlinkButton;
